// This file exports all contents of the module.

import * as axios from "./src/axios"
import * as definitions from "./src/definitions"
import * as storage from "./src/storage"
import * as useBypassKey from "./src/useBypassKey"

/**
 * Collection of definitions, methods, hooks, helpers
 * to work with the backend "maintenance mode" feature.
 *
 * When in MAINTENANCE_MODE, the backend responds any request with 503.
 * However, developers may need to work with a client that circumvents
 * this backend behaviour.
 * This is realized via a "bypass" method, i.e.:
 * When receiving the proper HTTP header, the backend responds normally.
 * The tools in this object help with managing this "bypass" methods
 * client-side.
 */
export const MaintenanceMode = {
  ...axios,
  ...definitions,
  ...storage,
  ...useBypassKey,
}
